import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Actions, ofActionCompleted, Select, Store} from '@ngxs/store';
import {Login, LoginError, LoginSuccess, SsoLogin} from '@shared/store/auth/auth.actions';
import {AuthState} from '@shared/store/auth/auth.state';
import {Observable, Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {Navigate} from '@ngxs/router-plugin';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslationService} from '@shared/services/translation.service';
import {MatDialog} from '@angular/material/dialog';
import {ForgetPasswordDialogComponent} from '@auth/pages/forget-password-dialog/forget-password-dialog.component';
import {AssetService} from '@shared/services/asset.service';
import {CaptchaDialogComponent} from '@auth/pages/captcha-dialog/captcha-dialog.component';
import packageJson from '../../../../../package.json';
import {RfidService} from '../../../shared/services/rfid.service';
import {SectionService} from '@shared/services/section/section.service';
import { ApiService } from '@app/shared/services/api.service';
import {AppConfigService} from '@shared/services/app-config.service';

@Component({
    selector: 'saf-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  @Select(AuthState.loading) loading$: Observable<boolean>;
  @ViewChild('rfidDiv') rfidDiv!: ElementRef;
  form: UntypedFormGroup;
  onDestroy$ = new Subject<void>();
  mainMandantLogo = '';
  showPassword = false;
  showSSO = false;
  public activateCaptcha: boolean;
  private countLoginAttempt = 0;
  private isAdmin = false;
  protected readonly packageJson = packageJson;
  private ssoPopup: Window | null = null;
  private ssoMessageHandler: ((event: MessageEvent) => void) | null = null;
  private ssoStorageHandler: ((event: StorageEvent) => void) | null = null;
  private ssoPoller: ReturnType<typeof setInterval> | null = null;

  constructor(
    private store: Store,
    private sectionService: SectionService,
    private assetService: AssetService,
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private translationService: TranslationService,
    private dialog: MatDialog,
    private rfidService: RfidService,
    private ApiService: ApiService,
    private appConfigService: AppConfigService
  ) {
  }

  ngOnInit() {
    this.showSSO = this.appConfigService.appConfig.showSSO;
    setTimeout(() => {
      this.companyLogoUrl();
    }, 200);

    this.form = new UntypedFormGroup({
      login: new UntypedFormControl('', Validators.required),
      password: new UntypedFormControl('', Validators.required),
      saveSession: new UntypedFormControl(true),
    }, {updateOn: 'submit'});

    this.actions$.pipe(
      ofActionCompleted(LoginSuccess),
      takeUntil(this.onDestroy$),
    ).subscribe(({action}) => {
      const payload = (action as LoginSuccess).payload;
      if (this.isAdmin = payload?.userDetails.user.systemUser === true) {
        this.onLoginSuccess('/'); //if this is systemuser redirect to employee list
      } else {
        this.onLoginSuccess('/'); //if this is not system user let see dashboard
      }
    });

    this.actions$.pipe(
      ofActionCompleted(LoginError),
      takeUntil(this.onDestroy$),
    ).subscribe(({action}) => this.onLoginError(action.payload));
  }

  onSubmit() {
    if (this.form.valid) {
      if (!localStorage.getItem('activateCaptcha')) {
        this.store.dispatch(new Login(this.form.value));
        this.countLoginAttempt++;
        if (this.countLoginAttempt > 1) {
          localStorage.setItem('activateCaptcha', 'true');
        }
      } else {
        this.dialog.open(CaptchaDialogComponent)
          .afterClosed()
          .pipe(filter((confirmed) => confirmed))
          .subscribe(() => this.store.dispatch(new Login(this.form.value)));
        return;
      }
    } else {
      this.countLoginAttempt++;
      if (this.countLoginAttempt > 1) {
        localStorage.setItem('activateCaptcha', 'true');
      }
      this.snackBar.open(this.translationService.translate('requiredFields'));
    }
  }

  onLoginSuccess(path: string) {
    const redirect = sessionStorage.getItem('redirect');

    if (redirect) {
      sessionStorage.removeItem('redirect');
    }
    this.store.dispatch(new Navigate([redirect || path]));
  }

  onLoginError({error}) {
    this.snackBar.open(this.translationService.translate(error || 'loginIncorrect'));
  }

  ngOnDestroy() {
    this.onDestroy$.next();

  }

  onClick() {
    this.rfidService.setFieldFocused(true);
  }

  onFocusChange(isFocused: boolean) {


    this.rfidService.setFieldFocused(true);


  }


  forgetPasswordDialog() {
    this.dialog.open(ForgetPasswordDialogComponent);
  }

  get avatarURL(): string {
    return this.assetService.getAssetURL(this.mainMandantLogo || '');
  }

  companyLogoUrl() {
    this.sectionService.getMainMandant().subscribe({
      next: data => {
        this.mainMandantLogo = data;
      },
      error: err => {
        console.error('Fehler beim Laden des Logos:', err);
      }
    });
  }





  loginWithMicrosoft(): void
  {

    window.location.href = `${this.ApiService.apiURL}/login/sso`;


  }










}
